// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Select */

.kJu6wv47CzaJFAIngInp {
	z-index: 1;
}

.LSHO07fZ7icM_O284aqG {
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	min-height: 25px;
	outline: none;
	cursor: pointer;
}

.chAL1dxHV_Vlz_hgeuCy {
	display: flex;
	flex-direction: row;
	align-items: center;
	min-height: 45px;
	box-sizing: border-box;
	padding: 10px;
}

.kJu6wv47CzaJFAIngInp:has(input[type="hidden"]:disabled) .dmLwxRcGZGDpfxRQYe32::after {
	border-top-color: #CCCCCC;
}

.LSHO07fZ7icM_O284aqG.nU6lRj86oJ0B8Gkk0WwR > .chAL1dxHV_Vlz_hgeuCy > .dmLwxRcGZGDpfxRQYe32::after {
	rotate: 180deg;
}

.OOtGartYdkO45pIP1kEg {
	position: absolute;
	display: flex;
	flex-direction: column;
	min-width: 100%;
	max-height: 40vh;
	max-height: 40dvh;
	top: calc(100% - 1px);
	right: -1px;
	margin: 0;
	padding: 0;
	list-style-type: none;
	background-color: #FFFFFF;
	box-shadow: 0px 4px 5px 0px rgb(0 0 0 / 10%);
	border: 1px solid #CCCCCC;
	overflow: auto;
	opacity: 0;
	visibility: hidden;
	transform: translateY(-10%);
	transition: transform 0.3s ease-in-out, opacity 0.3s, visibility 0.3s;
}

.LSHO07fZ7icM_O284aqG.ZxebceU_RURtrjVat2D_ > .OOtGartYdkO45pIP1kEg {
	left: -1px;
}

.LSHO07fZ7icM_O284aqG.S19a96w_XDBOAl35HANX > .OOtGartYdkO45pIP1kEg {
	right: -1px;
}

.LSHO07fZ7icM_O284aqG.jR8qZHaVBlKedf6trseQ > .OOtGartYdkO45pIP1kEg {
	display: none;
}

.LSHO07fZ7icM_O284aqG.nU6lRj86oJ0B8Gkk0WwR > .OOtGartYdkO45pIP1kEg {
	opacity: 1;
	transform: translateY(0);
	visibility: visible;
}

.aHuEQfPA33fDSZgjEPW8 {
	padding: 0;
	margin: 0;
	list-style-type: none;
}

.aHuEQfPA33fDSZgjEPW8 > li.UK2Xgi7NCdoDHGePw3BY {
	padding: 10px;
	font-weight: bold;
	cursor: default;
}

.aHuEQfPA33fDSZgjEPW8 > li.isRrobbCdYhxrCqj4C0u {
	padding-left: 5% !important;
}

.nDbQXVXAupYWNKuzJjYJ, .OOtGartYdkO45pIP1kEg li {
	font-size: 20px;
	color: #1D1D1B;
	-webkit-user-select: none;
	   -moz-user-select: none;
	        user-select: none;
}

.nDbQXVXAupYWNKuzJjYJ {
	flex: 1;
}

.OOtGartYdkO45pIP1kEg li.isRrobbCdYhxrCqj4C0u {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	min-height: 25px;
	padding: 5px;
	cursor: pointer;
}

.OOtGartYdkO45pIP1kEg li.isRrobbCdYhxrCqj4C0u:hover, .OOtGartYdkO45pIP1kEg li.isRrobbCdYhxrCqj4C0u.KsePhswA7cDWg26TyxSb {
	background-color: #BED4DB;
}

.OOtGartYdkO45pIP1kEg li.isRrobbCdYhxrCqj4C0u.zGNMvomdu8ovKROLU5Lg {
	background-color: #EFEFEF;
	color: #CCCCCC;
	cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/Select/style.module.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX;CACC,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,gBAAgB;CAChB,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,gBAAgB;CAChB,sBAAsB;CACtB,aAAa;AACd;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,qBAAqB;CACrB,WAAW;CACX,SAAS;CACT,UAAU;CACV,qBAAqB;CACrB,yBAAyB;CACzB,4CAA4C;CAC5C,yBAAyB;CACzB,cAAc;CACd,UAAU;CACV,kBAAkB;CAClB,2BAA2B;CAC3B,qEAAqE;AACtE;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,UAAU;CACV,wBAAwB;CACxB,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,SAAS;CACT,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,cAAc;CACd,yBAAiB;IAAjB,sBAAiB;SAAjB,iBAAiB;AAClB;;AAEA;CACC,OAAO;AACR;;AAEA;CACC,aAAa;CACb,2BAA2B;CAC3B,mBAAmB;CACnB,gBAAgB;CAChB,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd,eAAe;AAChB","sourcesContent":["/* Select */\r\n\r\n.container-element {\r\n\tz-index: 1;\r\n}\r\n\r\n.container {\r\n\tposition: relative;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tjustify-content: center;\r\n\tmin-height: 25px;\r\n\toutline: none;\r\n\tcursor: pointer;\r\n}\r\n\r\n.select {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\talign-items: center;\r\n\tmin-height: 45px;\r\n\tbox-sizing: border-box;\r\n\tpadding: 10px;\r\n}\r\n\r\n.container-element:has(input[type=\"hidden\"]:disabled) .arrow::after {\r\n\tborder-top-color: #CCCCCC;\r\n}\r\n\r\n.container.opened > .select > .arrow::after {\r\n\trotate: 180deg;\r\n}\r\n\r\n.select-list {\r\n\tposition: absolute;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tmin-width: 100%;\r\n\tmax-height: 40vh;\r\n\tmax-height: 40dvh;\r\n\ttop: calc(100% - 1px);\r\n\tright: -1px;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tlist-style-type: none;\r\n\tbackground-color: #FFFFFF;\r\n\tbox-shadow: 0px 4px 5px 0px rgb(0 0 0 / 10%);\r\n\tborder: 1px solid #CCCCCC;\r\n\toverflow: auto;\r\n\topacity: 0;\r\n\tvisibility: hidden;\r\n\ttransform: translateY(-10%);\r\n\ttransition: transform 0.3s ease-in-out, opacity 0.3s, visibility 0.3s;\r\n}\r\n\r\n.container.left > .select-list {\r\n\tleft: -1px;\r\n}\r\n\r\n.container.right > .select-list {\r\n\tright: -1px;\r\n}\r\n\r\n.container.hidden > .select-list {\r\n\tdisplay: none;\r\n}\r\n\r\n.container.opened > .select-list {\r\n\topacity: 1;\r\n\ttransform: translateY(0);\r\n\tvisibility: visible;\r\n}\r\n\r\n.optgpoup {\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tlist-style-type: none;\r\n}\r\n\r\n.optgpoup > li.label {\r\n\tpadding: 10px;\r\n\tfont-weight: bold;\r\n\tcursor: default;\r\n}\r\n\r\n.optgpoup > li.option {\r\n\tpadding-left: 5% !important;\r\n}\r\n\r\n.title, .select-list li {\r\n\tfont-size: 20px;\r\n\tcolor: #1D1D1B;\r\n\tuser-select: none;\r\n}\r\n\r\n.title {\r\n\tflex: 1;\r\n}\r\n\r\n.select-list li.option {\r\n\tdisplay: flex;\r\n\tjustify-content: flex-start;\r\n\talign-items: center;\r\n\tmin-height: 25px;\r\n\tpadding: 5px;\r\n\tcursor: pointer;\r\n}\r\n\r\n.select-list li.option:hover, .select-list li.option.active {\r\n\tbackground-color: #BED4DB;\r\n}\r\n\r\n.select-list li.option.disabled {\r\n\tbackground-color: #EFEFEF;\r\n\tcolor: #CCCCCC;\r\n\tcursor: default;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container-element": `kJu6wv47CzaJFAIngInp`,
	"container": `LSHO07fZ7icM_O284aqG`,
	"select": `chAL1dxHV_Vlz_hgeuCy`,
	"arrow": `dmLwxRcGZGDpfxRQYe32`,
	"opened": `nU6lRj86oJ0B8Gkk0WwR`,
	"select-list": `OOtGartYdkO45pIP1kEg`,
	"left": `ZxebceU_RURtrjVat2D_`,
	"right": `S19a96w_XDBOAl35HANX`,
	"hidden": `jR8qZHaVBlKedf6trseQ`,
	"optgpoup": `aHuEQfPA33fDSZgjEPW8`,
	"label": `UK2Xgi7NCdoDHGePw3BY`,
	"option": `isRrobbCdYhxrCqj4C0u`,
	"title": `nDbQXVXAupYWNKuzJjYJ`,
	"active": `KsePhswA7cDWg26TyxSb`,
	"disabled": `zGNMvomdu8ovKROLU5Lg`
};
export default ___CSS_LOADER_EXPORT___;
